export default {

  __dirname: 'https://n.163.com/h5/20190314/zhuanzhi/', // 正式地址
  // __dirname: 'https://test.nie.163.com/test_html/n/2019/0304/', // 测试地址


  // 最终得分
  score: [], // 最终的结果分数  0碎梦  1血河  2神相  3铁衣  4九灵  5素问  6龙吟
  // score: [55, 1, 2, 3, 4, 50, 30], // 测试
  // 男女
  sex: 0, // 1男  2女


  // 控制组件是否显示
  loading: true, // loading页是否显示
  videoCom: false, // videoCom页是否显示
  resVideo: false, // 罗盘+视频
  lastShow: false,
  lastCom: false, // 最终页面

  // 字体
  loadFont: false, // 字体加载状态


  prompt: false, // 提示锁屏组件是否显示  false不显示  true显示
  dev: true, // 标记pc还是mobile  true手机  false PC
  videoObj: null, // 视频对象
  audioObj: null, // 因屏对象
  resVideoObj: null, // 第二个视频对象
  recording: [0, 0, 0, 0, 0, 0, 0], // 记录分数   0碎梦  1血河  2神相  3铁衣  4九灵  5素问  6龙吟

  isWeiXin: false, // 是否是微信浏览器，true是  false不是
}